import withInit from "./withInit";

export default withInit;
